import { CurrencyPipe } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppConfigService } from '@core/services/config/app-config.service';
import { CartCookieService } from '@core/services/storage/cart/cart-cookie.service';
import { UserStoreService } from '@core/services/storage/user/user-store.service';
import { TranslatePipe } from 'src/app/core/pipe/translate.pipe';

@Component( {
    selector: 'app-min-price-alert',
    imports: [TranslatePipe, CurrencyPipe, RouterLink],
    templateUrl: './min-price-alert.component.html',
    styleUrl: './min-price-alert.component.scss'
} )
export class MinPriceAlertComponent {
    // services
    appConfig = inject(AppConfigService);
    cartCookieService = inject(CartCookieService);
    userStoreService = inject(UserStoreService);

    // local state
    min_price: number = this.appConfig.minCheckoutPriceGbp();

    // signals
    totaleCarrello = computed(() => {
        const cart = this.cartCookieService.cartValue(); // Ottiene il valore del signal
        const user = this.userStoreService.user();


        return this.cartCookieService.cartValue().articoli.reduce((total, item) => {

                let price: number = item.prezzo_privati_vat;
                if(this.userStoreService.isLoggedSignal()) {
                    if(this.userStoreService.paga() == 'CON') {
                        if(this.userStoreService.isPrivateSignal()) {
                            price = item.prezzo_privati_vat;
                        }
                        if(this.userStoreService.isProSignal()) {
                            price = item.prezzo_pro_vat;
                        }
                    }
                    if(this.userStoreService.paga() == 'SENZA') {
                        if(this.userStoreService.isPrivateSignal()) {
                            price = item.prezzo_privati_novat;
                        }
                        if(this.userStoreService.isProSignal()) {
                            price = item.prezzo_pro_novat;
                        }
                    }
                }

                return total + (price * item.item_quantita);
            }
           , 0
        )
    });

}
